import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';

export default function ContactTenantsSmall({
  isOpen,
  onToggle,
  endpoint = "home/all",
  redirectOnAuthError = true,
}) {
  const history = useHistory();

  const [multiTenantList, setMultiTenantList] = useState([]);

  useEffect(() => {
    const loadContactTenants = async () => {
      try {
        const response = await axios.get(configData.LANDNOTIFICATION_SERVER_URL + endpoint, { withCredentials: true });
        const content = response.data.content;
        if (content.multiTenantList && content.multiTenantList.paragraphs && content.multiTenantList.paragraphs.length > 0) {
          setMultiTenantList(content.multiTenantList.paragraphs);
        }
      } catch (error) {
        if (redirectOnAuthError) {
          handleError(error, history);
        } else {
          console.error("Failed to load contact tenants:", error);
        }
      }
    };

    loadContactTenants();
  }, [history, endpoint, redirectOnAuthError]);

  return (
    <div
      style={{
        ...styles.container,
        boxShadow: isOpen
          ? "0 4px 10px rgba(0,0,0,0.08)"
          : "0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          ...styles.header,
          backgroundColor: isOpen ? "#5A6268" : "#6C757D",
        }}
        onClick={onToggle}
      >
        <span>Contact Us</span>

        {/* Arrow with smooth rotation */}
        <span
          style={{
            ...styles.icon,
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            display: "inline-block",
          }}
        >
          ▼
        </span>
      </div>

      {/* Animated Content */}
      <div
        style={{
          ...styles.wrapper,
          maxHeight: isOpen ? "2000px" : "0px",
        }}
      >
        <div
          style={{
            ...styles.content,
            opacity: isOpen ? 1 : 0,
            transition: "opacity 0.2s ease 0.08s",
          }}
        >
          {multiTenantList.map((tenant, index) => (
            <div key={index} style={styles.tenantBlock}>
              <div style={styles.tenantName}>{tenant.paragraphContentOne}</div>
              <div style={styles.tenantDetail}><a href={`mailto:${tenant.emailAddress}`} style={styles.link}>{tenant.emailAddress}</a></div>
              <div style={styles.tenantDetail}><a href={`tel:${(tenant.phone || "").replace(/[^\d+]/g, "")}`} style={styles.link}>{tenant.phone}</a></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Styles
const styles = {

  container: {
    marginTop: "16px",
    border: "2px solid #6C757D",
    borderRadius: "6px",
    overflow: "hidden",
    transition: "box-shadow 0.3s ease",
    boxShadow: "0 4px 12px rgba(108, 117, 125, 0.12)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: "#6C757D",
    fontWeight: "bold",
    color: "white",
    transition: "background-color 0.2s ease",
  },

  icon: {
    fontSize: "12px",
  },

  wrapper: {
    overflow: "hidden",
    transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  content: {
    padding: "12px",
    backgroundColor: "white",
    fontSize: "14px",
    lineHeight: "1.5",
  },

  tenantBlock: {
    padding: "8px 0",
    borderBottom: "1px solid #eee",
  },

  tenantName: {
    fontWeight: "bold",
    color: "#444",
  },

  tenantDetail: {
    color: "#444",
  },

  link: {
    color: "#114E6B",
    fontWeight: "bold",
    textDecoration: "underline",
  },

};
